/**
 * Type-safe routing system for ConductorOne frontend.
 *
 * @example
 * import { routes } from 'lib/routes'
 *
 * // Use with C1Link
 * <C1Link href={routes.applications.detail(appId)}>View App</C1Link>
 */
export { routes } from './routes'
export type { Route } from './types'
export { route, unsafeRoute } from './types' // For edge cases where you need to create a route manually
